import { allPhotos } from "./allPhotos";

export const fifteenPhotos = allPhotos.filter(function(obj) { return obj.type === '15 anos'; });